import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { SubSearchParamEnum } from '../../common/types/searchParams'

const useBusinessAppsFilters = () => {
  const [searchParams] = useSearchParams()

  // Initialize visualization mode.
  const [isIgnoreWeekendsActive, setIsIgnoreWeekendsActive] = useState<boolean>(
    searchParams.get(SubSearchParamEnum.IGNORE_WEEKENDS) === 'true',
  )

  useEffect(() => {
    const ignoreWeekendsParam = searchParams.get(SubSearchParamEnum.IGNORE_WEEKENDS)

    if (ignoreWeekendsParam === 'true') {
      setIsIgnoreWeekendsActive(true)
    } else {
      setIsIgnoreWeekendsActive(false)
    }
  }, [searchParams.get(SubSearchParamEnum.IGNORE_WEEKENDS)]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    isIgnoreWeekendsActive,
  }
}

export default useBusinessAppsFilters

